import React from "react";

export function ArrowDownIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="rgba(107,95,80,1)"
      {...props}
    >
      <path d="M12 14L8 10H16L12 14Z"></path>
    </svg>
  );
}
